import ApplicationSerializer from './application';

export default class BlacklistFilterSerializer extends ApplicationSerializer {
  attrs = {
    createdBy: { serialize: false },
    photo: { serialize: false }, // photo upload/delete is managed seperately as an attachment
  };
}
